import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widgets-list',
  templateUrl: './widgets-list.component.html',
})
export class WidgetsListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
